import { Outlet } from 'react-router-dom';
import ConfigAdminProjectLayout from '../../../theme/templates/project/admin';

const ProjectPage = () => (
  <ConfigAdminProjectLayout>
    <Outlet />
  </ConfigAdminProjectLayout>
)

export default ProjectPage;
